import {
    SET_ORG_CUSTOMIZATIONS_BY_ORG_ID,
    REPLACE_ORG_CUSTOMIZATIONS,
} from "./actionTypes";

/**
 * Hardcoded org UI customizations.
 * Later this will be populated from the backend.
 * Only org 21089 is customized for now.
 */
export const HARDCODED_ORG_CUSTOMIZATIONS = {
    "21089": {
        general: {
            landingTitle: "What would you like to submit?",
        },
        gd: {
            dataBreachTitle: "Data Protection Incident",
            otherRequestTitle: "Rights Requests",
            otherRequestBtn: "Submit",
            moduleTitle: "Incident or Request",
            moduleDesc:
                "Report a data protection incident or submit a request to exercise your data protection rights.",
            hideSalutation: true,
        },
        cm: {
            reportConfidentiallyTitle: "Your complaint",
            reportConfidentiallyDesc:
                "Your complaint will be handled confidentially. We will use the information you provide to investigate your complaint and respond to you.",
            reportConfidentiallyBtn: "Submit a complaint",
            moduleTitle: "Complaint",
            moduleDesc:
                "Submit a complaint if you are unhappy with how FCC Environment has handled your personal data or responded to your data protection request.",
            confidentialReport: {
                hidePositionFromConfidentialReport: true,
                organizationAsLegalEntitySelect: true,
                organizationLabel:
                    "Which organisation does your complaint relate to?",
                organizationOptional: true,
                // Set to false to show the customized organization question again.
                hideOrganizationFromConfidentialReport: true,
                relationCompanyLabel:
                    "Which best describes your relationship with FCC Environment?",
                relationCompanyOptions: [
                    "Current employee",
                    "Former employee",
                    "Member of the public",
                    "Job applicant",
                    "Other",
                ],
                relationCompanyAsSelect: true,
                hideSalutation: true,
                hideComplaintTitleFromConfidentialReport: false,
                complaintTitleLabel:
                    "Which part of FCC Environment does your complaint relate to?",
                // First name → Last name → relation → location → (title/category) → dynamic questions
                useCustomStaticQuestionOrder: true,
            },
        },
    },
};

const initialState = {
    byOrgId: HARDCODED_ORG_CUSTOMIZATIONS,
};

export const OrgCustomizations = (state = initialState, action) => {
    switch (action.type) {
        case SET_ORG_CUSTOMIZATIONS_BY_ORG_ID: {
            const { orgId, customizations } = action.payload || {};
            if (!orgId) {
                return state;
            }

            return {
                ...state,
                byOrgId: {
                    ...state.byOrgId,
                    [orgId]: {
                        ...(state.byOrgId[orgId] || {}),
                        ...(customizations || {}),
                    },
                },
            };
        }
        case REPLACE_ORG_CUSTOMIZATIONS:
            return {
                ...state,
                byOrgId: action.payload || {},
            };
        default:
            return state;
    }
};

export const selectOrgCustomization = (state, orgId) => {
    if (orgId === null || orgId === undefined || orgId === "") {
        return null;
    }

    return state?.OrgCustomizations?.byOrgId?.[String(orgId)] || null;
};
